import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <motion.div className={`bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden ${noPadding ? '' : 'p-6'} ${className}`} {...props} data-id="element-228">
      {children}
    </motion.div>;
}